export default __webpack_public_path__ + "static/dge_medium_2-2c3474c87ea0ef47e7d16b0077cdf0cf.webp";